const GetProjectMainImage = (project) => {
    if (!project.medias) return null;
    for (let i = 0; i < project.medias.length; i++) {
        if (project.medias[i].type.includes("image")) {
            return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + project.medias[i].path;
        }
    }
    return null;
}

export default GetProjectMainImage;